import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Text, VStack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

import React from 'react';
import { validarCPF } from '@/utils/validateDocuments';
import { updateCPF } from '@/service/subscription/api';
import { Button } from '../atoms/Button';
import { Input } from '../atoms/Input';

export const ModalCPF = ({
  isOpen,
  onClose,
  document,
}: {
  isOpen: boolean;
  onClose: (cpf: string) => void;
  document?: string;
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  async function doUpdateProfile(data: Record<string, string>) {
    setIsLoading(true);

    // Validação do CPF
    if (!validarCPF(data.cpf)) {
      setError('cpf', {
        type: 'manual',
        message: 'CPF inválido',
      });
      setIsLoading(false);
      return;
    }

    // Verifica se o documento (CNPJ) está presente
    if (!document) {
      setError('cpf', {
        type: 'manual',
        message: 'CNPJ não encontrado. Tente novamente.',
      });
      setIsLoading(false);
      return;
    }

    try {
      await updateCPF({
        cnpj: document.replace(/\D/g, ''),
        document_for_cnpj: data.cpf.replace(/\D/g, ''),
      });
      onClose(data.cpf);
    } catch {
      setError('cpf', {
        type: 'manual',
        message: 'Erro ao atualizar CPF. Tente novamente.',
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>CNPJ encontrado!</ModalHeader>
        <ModalBody>
          <VStack>
            <Text>Para continuar precisamos vincular seu CPF a sua conta. Por favor, preencha o campo abaixo.</Text>
            <form onSubmit={handleSubmit(doUpdateProfile)} style={{ width: '100%' }}>
              <Input control={control} name="cpf" label="CPF" />
              {errors.cpf && typeof errors.cpf.message === 'string' && (
                <Text fontSize={12} color="red.500">
                  {errors.cpf.message}
                </Text>
              )}
            </form>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button isLoading={isLoading} onClick={handleSubmit(doUpdateProfile)}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
